<template>
	<div>
		<div ref="editorTitle" class="toolbar">
		</div>
		<div ref="editorCon" class="toolbar" :style="{height: myHeight}">
			<p>请输入内容</p>
		</div>
	</div>
</template>

<script>
	import E from 'redcoral-wangeditor'

	export default {
		name: 'editor',
		props: {
			initContent: {
				type: String,
				default: ""
			},
			initHeight: {
				type: String,
				default: "300px"
			}
		},
		data() {
			return {
				editorContent: this.initContent,
				editor: null,
				myHeight: '300px'
			}
		},
		watch: {
			"initContent": function(newVal, oldVal) {
				this.editorContent = newVal;
				this.editor.txt.html(this.editorContent);
				var txt = this.editor.txt.text();
				this.$emit("contentChanged", this.editorContent, txt);
			}
		},
		created() {
			this.setOption()
		},
		methods: {
			setOption() {
				this.myHeight = this.initHeight
			},
			setHtml(txt) {
				this.editor.txt.html(txt)
			},
			capture() {
				let content = jsObj.Invoke("CaptureImage", "");
				let base64img = "data:image/png;base64," + content;
				let imghtml = '<img src="' + base64img + '" style="max-width:100%;">';
				this.setAppendContent(imghtml);
			},
			getContent: function() {
				return this.editorContent
			},
			setContent: function(txt) {
				this.editor.txt.html(txt)
			},
			setAppendContent: function(val) {
				this.editor.txt.append(val)
				// this.editor.cmd.do('insertHTML', val)
			},
		},
		mounted() {
			this.editor = new E(this.$refs.editorTitle, this.$refs.editorCon);
			this.editor.customConfig.zIndex = 100;
			this.editor.customConfig.uploadImgShowBase64 = true // 使用 base64 保存图片
			this.editor.customConfig.pasteIgnoreImg = true
			this.editor.customConfig.menus = [
				'head', // 标题
				'bold', // 粗体
				'fontSize', // 字号
				'fontName', // 字体
				'underline', // 下划线
				'foreColor', // 文字颜色
				'backColor', // 背景颜色
				'link', // 插入链接
				'list', // 列表
				'justify', // 对齐方式
				'quote', // 引用
				'emoticon', // 表情
				'image', // 插入图片
				'table', // 表格
			]
			this.editor.customConfig.onchange = (html) => {
				this.editorContent = html;
				var txt = this.editor.txt.text();
				this.$emit("contentChanged", this.editorContent, txt);
			}
			this.editor.create();
			this.editor.txt.html(this.initContent); // 设置内容
		}
	}
</script>

<style scoped>
	.toolbar {
		border: 1px solid #ccc;
	}
</style>